import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewToggleComponent } from './preview-toggle/preview-toggle.component';
import { AddressSearchComponent } from './address-search/address-search.component';
import { FormsModule } from '@angular/forms';
import { SearchDropdownComponent } from './search-dropdown/search-dropdown.component';

@NgModule({
  declarations: [
    PreviewToggleComponent,
    AddressSearchComponent,
    SearchDropdownComponent
    
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    AddressSearchComponent,
    SearchDropdownComponent

  ]
})
export class ToolsModule { }
